import { track } from "../track";

export const trackUploadBackgroundScs = () => track({ event: "upload_background_scs" });
